<template>
	<div class="edit">
		<div class="contains">
			<div class="box">
				<div class="section">
					<div class="lable">真实姓名</div>
					<div class="content">
						<div class="option">
							<el-input placeholder="请输入真实姓名" v-model="User.RealName"></el-input>
						</div>
					</div>
				</div>
				<div class="section">
					<div class="lable">昵称</div>
					<div class="content">
						<div class="option">
							<el-input placeholder="昵称" v-model="User.NickName"></el-input>
						</div>
					</div>
				</div>
				<div class="section">
					<div class="lable">
						手机号
						<span style="color:red">*</span>
					</div>
					<div class="content">
						<div class="option">
							<el-input placeholder="请输入手机号" v-model="User.Mobile" maxlength="11"></el-input>
						</div>
					</div>
				</div>

				<div class="section">
					<div class="lable">
						账号
						<span style="color:red">*</span>
					</div>
					<div class="content">
						<div class="option">
							<el-input placeholder="请输入账号" v-model="User.Account"></el-input>
						</div>
					</div>
				</div>
				<div class="section">
					<div class="lable">
						初始密码
						<span style="color:red">*</span>
					</div>
					<div class="content">
						<div class="option">
							<el-input placeholder="请输入密码" password v-model="User.Password"></el-input>
						</div>
					</div>
				</div>
				<div class="section">
					<div class="lable">
						接待人数
						<span style="color:red">*</span>
					</div>
					<div class="content">
						<div class="option special">
							接待人数
							<el-input style="width:130px" v-model="User.MaxAccess"></el-input>人
						</div>
					</div>
				</div>

				<div class="section">
					<div class="lable">
						选择角色
						<span style="color:red">*</span>
					</div>
					<div class="content">
						<div class="option">
							<el-select v-model="User.RoleId" placeholder="所有角色">
								<el-option v-for="item in option1" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
							</el-select>
						</div>
					</div>
				</div>

				<div class="section">
					<div class="lable">
						选择分组
						<span style="color:red">*</span>
					</div>
					<div class="content">
						<div class="option last">
							<el-input placeholder="搜索分组" v-model="input" style="width:400px" v-on:input="changeCount"></el-input>
							<span class="txt">
								已分配组：
								<span class="count" v-html="count"></span>
							</span>
						</div>
						<div class="group">
							<div class="z-empty" v-if="show">
								<p>没有可选的分组</p>
							</div>
							<div class="series">
								<ul class="list">
									<li
										v-for="(item,index) in list"
										@click="choose(item.id,index)"
										v-if="item.booleam"
										:key="index"
									>{{item.name}}</li>
								</ul>
							</div>
							<div class="series special">
								<ul class="list">
									<li v-for="(item,index) in list2" @click="choose1(item.id,index)">
										<p>{{item.name}}</p>
										<div class="close">x</div>
									</li>
								</ul>
							</div>
							<div class="none" v-if="show2">
								<p>暂无分组</p>
							</div>
						</div>
						<div class="btn_box">
							<el-button type="primary" class="save" @click="add">{{ButtonName}}</el-button>
							<el-button @click="cancel">取消</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'edit',
	props: ['shu'],
	data() {
		return {
			input: '',
			User: {
				Id: 0,
				ConversationId: '',
				HeadImg: '',
				Account: '',
				Password: '',
				MaxAccess: '',
				RealName: '',
				NickName: '',
				Mobile: '',
				Email: '',
				RoleId: '',
				CreateTime: '2019-12-31',
				UpdateTime: '2019-12-31',
				CurrentStateId: 0,
				IsDelete: 1,
				Online: 0
			},
			value: '',
			count: 0,
			list: [{ title: '分组1' }, { title: '分组2' }],
			list2: [],
			show: false,
			show2: false,
			option1: [],
			ButtonName: '保存'
		}
	},
	watch: {},
	mounted: function() {
		this.SelectList()
		this.GroupVm()
	},
	created() {},
	methods: {
		UpdateModel() {
			let $this = this
			this.axios
				.get(
					'User/UpdateModel',
					{
						params: { UserID: $this.shu }
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					$this.User.ConversationId = data.data.conversationId
					$this.User.HeadImg = data.data.headImg
					$this.User.Account = data.data.account
					$this.User.Password = data.data.password
					$this.User.MaxAccess = data.data.maxAccess
					$this.User.RealName = data.data.realName
					$this.User.NickName = data.data.nickName
					$this.User.Mobile = data.data.mobile
					$this.User.Email = data.data.email
					$this.User.RoleId = data.data.roleId
					$this.User.CreateTime = data.data.createTime
					$this.User.UpdateTime = data.data.updateTime
					$this.User.CurrentStateId = data.data.currentStateId
					$this.User.IsDelete = data.data.isDelete
					$this.User.Online = data.data.online
					$this.User.Id = data.data.id
					data.data.list.forEach(element => {
						$this.list.forEach(element1 => {
							if (element.groupId == element1.id) {
								$this.list2.push(element1)
								//  $this.list1.splice(element1,1);
								let index = $this.list.indexOf(element1)
								$this.list.splice(index, 1)
								$this.count = $this.list2.length
							}
						})
					})
				})
		},
		changeCount() {
			let $this = this
			if ($this.input == '') {
				$this.list.forEach(element => {
					element.booleam = true
				})
			} else {
				$this.list.forEach(element => {
					if (element.name.indexOf($this.input) == -1) {
						element.booleam = false
					} else {
						element.booleam = true
					}
				})
			}
		},
		GroupVm() {
			let $this = this
			this.axios
				.get('Group/GroupVm', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					$this.list = data.data
					if ($this.shu != 0) {
						$this.UpdateModel()
						$this.ButtonName = '修改'
					}
				})
		},
		SelectList() {
			let $this = this
			this.axios
				.get('Role/SelectList', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					$this.option1 = data.data
					$this.User.RoleId = $this.option1[0].id
				})
		},
		choose(id, index) {
			let $this = this
			$this.list2.push($this.list[index])
			$this.list.splice(index, 1)
			$this.count = $this.list2.length
		},
		choose1(id, index) {
			let $this = this
			$this.list.push($this.list2[index])
			$this.list2.splice(index, 1)
			$this.count = $this.list2.length
		},
		cancel() {
			//取消
			this.$emit('id', 'manage')
		},
		add() {
			var patrn = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,12}$/
			let $this = this
			var boolean = true
			if ($this.User.Account == '') {
				$this.$message.error('账号不能为空')
				boolean = false
			}else if($this.User.Account.length>30){
				$this.$message.error('账号长度不能超过30字符')
				boolean = false
			} 
			else if ($this.User.Password == '') {
				$this.$message.error('初始密码不能为空')
				boolean = false
			}else if($this.User.Password.length>16){
				$this.$message.error('密码长度不能超过16位')
				boolean = false
			} 
			else if ($this.User.MaxAccess == '') {
				$this.$message.error('接待人数不能为空')
				boolean = false
			} else if ($this.count == 0) {
				$this.$message.error('分组不能为空')
				boolean = false
			} else if ($this.User.Mobile == '') {
				$this.$message.error('手机号不能为空')
				boolean = false
			} else if ($this.User.NickName == '') {
				$this.$message.error('昵称不能为空')
				boolean = false
			}else if($this.User.NickName.length>30){
				$this.$message.error('昵称不能超过30字符')
				boolean = false
			}

			if (boolean) {
				if ($this.shu != 0) {
					this.axios
						.post('User/Update', $this.User, {
							headers: {
								'Content-Type': 'application/json'
							}
						})
						.then(function(data) {
							if (data.data.message == '成功') {
								$this.axios
									.post(
										'UserGroupRelation/Delete?UserID=' +
											$this.shu,
										{
											headers: {
												'Content-Type':
													'application/json'
											}
										}
									)
									.then(function(data1) {
										if (data1.data.message == '成功') {
											$this.list2.forEach(element => {
												element.UserId = data1.data.id
												element.GroupId = element.id
											})
											$this.axios
												.post(
													'UserGroupRelation/Add',
													$this.list2,
													{
														headers: {
															'Content-Type':
																'application/json'
														}
													}
												)
												.then(function(data2) {
													if (
														data2.data.message ==
														'成功'
													) {
														$this.$message(
															data2.data.message
														)
														
														$this.$emit(
															'id',
															'manage'
														)
													} else {
														$this.$message.error(
															data2.data.message
														)
													}
												})
										} else {
											$this.$message.error(data1.data.message)
										}
									})
							} else {
								$this.$message.error(data.data.message)
							}
						})
				} else {
					this.axios
						.post('User/Add', $this.User, {
							headers: {
								'Content-Type': 'application/json'
							}
						})
						.then(function(data) {
							if (data.data.message == '成功') {
								$this.list2.forEach(element => {
									element.UserId = data.data.id
									element.GroupId = element.id
								})
								$this.axios
									.post(
										'UserGroupRelation/Add',
										$this.list2,
										{
											headers: {
												'Content-Type':
													'application/json'
											}
										}
									)
									.then(function(data1) {
										if (data1.data.message == '成功') {
											$this.$message(data1.data.message)
											$this.$emit('id', 'manage')
											//   $this.$router.push({ path: '/manage/staff' })
										} else {
											$this.$message.error(data1.data.message)
										}
									})
							} else {
								$this.$message.error(data.data.message)
							}
						})
				}
			}
		}
	}
}
</script>

<style scoped>
.contains {
	padding: 50px 0px;
}
.box {
	padding-top: 100px;
}
.section {
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	margin-bottom: 25px;
}
.lable {
	width: 150px;
	text-align: right;
	line-height: 40px;
	height: 40px;
	margin-right: 20px;
}
.option {
	line-height: 40px;
	height: 40px;
}
.group {
	margin-top: 20px;
	display: -webkit-flex; /*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.none {
	width: 370px;
	height: 200px;
	text-align: center;
	border: 1px solid #ddd;
	margin-left: 20px;
	flex-grow: 1;
	-webkit-flex-grow: 1;
	-moz-border-radius: 2px;
	border-radius: 2px;
	margin-top: 10px;
	display: flex;
	display: -webkit-flex;
	align-items: center;
	-webkit-align-items: center;
	justify-content: center;
	-webkit-justify-content: center;
}
.txt {
	margin-left: 20px;
}
.series {
	width: 370px;
	height: 200px;
	border: 1px solid #ddd;
	overflow-y: auto;
}
.series.special {
	margin-left: 20px;
}
.list li {
	cursor: pointer;
	height: 30px;
	padding: 8px 10px;
	box-sizing: border-box;
	white-space: nowrap;
	display: flex;
	display: -webkit-flex;
	align-items: center;
	-webkit-align-items: center;
	justify-content: space-between;
	-webkit-justify-content: space-between;
}
.close {
	width: 15px;
	height: 15px;
	text-align: center;
	line-height: 15px;
}
.btn_box {
	margin-top: 30px;
}
</style>
<style>
.edit .el-input__inner {
	background-color: transparent;
	width: 400px;
	line-height: 40px;
	height: 40px;
}
.special.option .el-input__inner {
	width: 100px;
	margin: 0 20px;
}
.special.option .el-input {
	display: inline-block;
}
.option.last .el-input__inner {
	width: 370px;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/staff/edit.vue